export default "__VITE_ASSET__lsUlj5UA__"